import Routes from '@/lib/router/routes';

const mapInternalLinkToRoutes = {
  'sign-up': Routes.SignUpRegister,
  opportunities: Routes.Projects,
  'typeform-get-funded': '#typeForm',
};

export default mapInternalLinkToRoutes;
